module.exports = __webpack_public_path__ + "40a07a2fcd21722fa54142917ff4fb76.png";